import { CheckCircle, XCircle } from 'react-feather';
import Group from '../Group';

export default function PasswordRules({
  password = '',
}: {
  password?: string;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Group gap={8}>
        {password?.length >= 8 ? (
          <CheckCircle size={16} color="green" />
        ) : (
          <XCircle size={16} color="red" />
        )}
        <span style={{ color: 'darkgray' }}> 8 ou mais caracteres</span>
      </Group>

      <Group gap={8}>
        {/[A-Z]/.test(password) ? (
          <CheckCircle size={16} color="green" />
        ) : (
          <XCircle size={16} color="red" />
        )}
        <span style={{ color: 'darkgray' }}>Letra maiúscula</span>
      </Group>

      <Group gap={8}>
        {/[a-z]/.test(password) ? (
          <CheckCircle size={16} color="green" />
        ) : (
          <XCircle size={16} color="red" />
        )}
        <span style={{ color: 'darkgray' }}>Letra minúscula</span>
      </Group>
      <Group gap={8}>
        {/[0-9]/.test(password) ? (
          <CheckCircle size={16} color="green" />
        ) : (
          <XCircle size={16} color="red" />
        )}
        <span style={{ color: 'darkgray' }}>Número</span>
      </Group>
    </div>
  );
}
